import { useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";

export default function useQuery() {
  const history = useHistory();

  const setQueryParam = useCallback(
    (name: string, value: string) => {
      const searchParams = new URLSearchParams();
      searchParams.set(name, value);
      history.push({ search: searchParams.toString() });
    },
    [history],
  );

  return {
    queryParams: new URLSearchParams(useLocation().search),
    setQueryParam,
  };
}
